import { Clock, MapPin, ExternalLink, BadgePercent } from "lucide-react";
import { api } from "@/lib/api";
import { catInfo } from "@/lib/constants";

const nowHM = () => new Date().toTimeString().slice(0, 5);
export const activeNow = (slots = []) => slots.some((s) => s.start <= nowHM() && nowHM() < s.end);

export const SlotList = ({ slots }) => (
  <span className="flex flex-wrap gap-1">
    {slots.map((s) => (
      <span key={`${s.start}-${s.end}`} className="inline-flex items-center gap-1 text-[11px] font-mono font-semibold px-2 py-0.5 rounded-full bg-[#E3EFE6] text-[#0F2A1F]">
        <Clock className="w-3 h-3" /> {s.start}–{s.end}
      </span>
    ))}
  </span>
);

export const AdCard = ({ ad, testId, showNow = true, footer }) => {
  const Icon = catInfo(ad.category).icon;
  const now = activeNow(ad.time_slots);
  return (
    <div data-testid={testId} className="rounded-2xl border border-[#B8892B]/40 bg-gradient-to-br from-[#FBF7EA] to-white p-4 space-y-2">
      <div className="flex items-center gap-2 flex-wrap">
        <span data-testid="honest-label-sponsored-deal" className="text-[11px] font-mono font-bold px-2 py-0.5 rounded-full bg-[#B8892B] text-white">SPONSORED · LOCAL BUSINESS</span>
        {showNow && (now
          ? <span className="text-[11px] font-semibold text-[#2F7D55]">Deal active now</span>
          : <span className="text-[11px] text-stone-500">Deal times only</span>)}
        {ad.km != null && <span className="text-[11px] text-stone-500 flex items-center gap-0.5"><MapPin className="w-3 h-3" /> {ad.km} km away</span>}
      </div>
      <p className="text-xs font-semibold text-stone-500 flex items-center gap-1"><Icon className="w-3.5 h-3.5" /> {ad.business_name} · {catInfo(ad.category).label}</p>
      <h4 className="font-bold text-stone-900 leading-tight">{ad.title}</h4>
      <p className="text-sm font-semibold text-[#7A6A1F] flex items-center gap-1.5"><BadgePercent className="w-4 h-4 shrink-0" /> {ad.offer}</p>
      {ad.description && <p className="text-sm text-stone-600">{ad.description}</p>}
      <SlotList slots={ad.matching_slots || ad.time_slots} />
      <div className="flex items-center justify-between gap-2 pt-1">
        <span className="text-xs text-stone-500 truncate">{ad.location?.label}</span>
        {/^https?:\/\//i.test(ad.link || "") && (
          <a href={ad.link} target="_blank" rel="noopener noreferrer" onClick={() => api.post(`/ads/${ad.id}/click`).catch(() => {})} data-testid={`${testId}-link`}
            className="shrink-0 text-xs font-semibold text-[#23603F] flex items-center gap-1 hover:underline">Visit <ExternalLink className="w-3 h-3" /></a>
        )}
      </div>
      {footer}
    </div>
  );
};
